import { TRANSLATION_NAMESPACES } from 'core/constants/constants';
import { env } from 'core/constants/env.constants';
import { Language } from './user-language.api';

export const getLanguages = async (options?: { signal?: AbortSignal }): Promise<Language[]> => {
    const translationsUrl = new URL(env.VITE_TRANSLATIONS_API);
    const response = await fetch(`${translationsUrl.origin}/list_languages.json`, options);

    if (!response.ok) {
        throw new Error('Failed to load languages list');
    }

    return response.json();
};

export const getTranslations = async <T = JSON>(
    userLanguage: string,
    options?: { signal?: AbortSignal }
): Promise<T> => {
    const translationsUrl = new URL(env.VITE_TRANSLATIONS_API);

    const responses = await Promise.all(
        TRANSLATION_NAMESPACES.map(async (namespace) => {
            const response = await fetch(`${translationsUrl.origin}/${userLanguage}/${namespace}.json`, options);

            if (!response.ok) {
                throw new Error(`Failed to load translations "${namespace}" for language "${userLanguage}".`);
            }

            return response.json();
        })
    );

    return Object.assign({}, ...responses) as T;
};
